import React, { useState } from "react";
import '../css/navbar.css';
import "@fortawesome/fontawesome-free/css/all.min.css";

const menuItems = [
    { name: "🏠︎", link: "/hi" },


    {
        name: " विश्वविद्यालय",
        dropdown: [
            { name: "विश्वविद्यालय परिचय ", link: "/hi/विश्वविद्यालय/विश्वविद्यालय-के-बारे-में" },
            { name: "दृष्टि, ध्येय एवं उद्देश्य", link: "/hi/विश्वविद्यालय/दृष्टि-ध्येय-एवं-उद्देश्य" },
            { name: "कुलाधिपति सन्देश", link: "/hi/विश्वविद्यालय/कुलाधिपति-संदेश" },
            { name: "कुलपति सन्देश", link: "/hi/विश्वविद्यालय/कुलपति-संदेश" },
            { name: "कुलसचिव सन्देश", link: "/hi/विश्वविद्यालय/कुलसचिव-संदेश" },

            {
                name: "विश्वविद्यालय सदस्य", link: "/hi/विश्वविद्यालय/विश्वविद्यालय-सदस्य"

            },

            { name: "विश्वविद्यालय अधिनियम", link: "/hi/विश्वविद्यालय/विश्वविद्यालय-अधिनियम" },
            { name: "कुलगीत", link: "/hi/विश्वविद्यालय/कुलगीत" },
            { name: "परिसर दृश्य", link: "/hi/विश्वविद्यालय/परिसर-दृश्य" },
            { name: "मार्गदर्शक चित्र", link: "/hi/विश्वविद्यालय/मार्गदर्शक-चित्र" },
        ]
    },


    {
        name: "प्रशासन",
        dropdown: [

            {
                name: "वैधानिक निकाय",
                dropdown: [
                    { name: "कार्य परिषद्", link: "/hi/प्रशासन/वैधानिक-निकाय/कार्य-परिषद्" },
                    { name: "विद्वत परिषद्	", link: "/hi/प्रशासन/वैधानिक-निकाय/विद्वत-परिषद्" },
                    { name: "वित्त समिति", link: "/hi/प्रशासन/वैधानिक-निकाय/वित्त-समिति" },
                    { name: "शैक्षणिक योजना बोर्ड", link: "/hi/प्रशासन/वैधानिक-निकाय/शैक्षणिक-योजना-बोर्ड" },
                    { name: "विश्वविद्यालय कोर्ट", link: "/hi/प्रशासन/वैधानिक-निकाय/विश्वविद्यालय-कोर्ट" }
                ]
            },

            {
                name: "विश्वविद्यालय के अधिकारी",
                dropdown: [
                    { name: "कुलाधिपति", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलाधिपति" },
                    { name: "कुलपति", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलपति" },
                    { name: "कुलसचिव", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलसचिव" },
                    { name: "कुलानुशासक", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलानुशासक" },
                    { name: "शैक्षणिक अधिष्ठाता", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/शैक्षणिक-अधिष्ठाता" },
                    { name: "छात्र कल्याण अधिष्ठाता", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/छात्र-कल्याण-अधिष्ठाता" },
                    { name: "महाविद्यालय अधिष्ठाता", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/महाविद्यालय-अधिष्ठाता" },
                    { name: "मुख्य संरक्षक/वार्डन", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/मुख्य-संरक्षक" },
                    { name: "वित्ताधिकारी", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/वित्ताधिकारी" },
                    { name: "परीक्षा नियंत्रक", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/परीक्षा-नियंत्रक" },
                    { name: "पुस्तकालयाध्यक्ष", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/पुस्तकालयाध्यक्ष" },
                    { name: "अधिष्ठाता/संकाय प्रमुख", link: "/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/अधिष्ठाता" },
                ]
            },

            { name: "लोकपाल", link: "/hi/प्रशासन/लोकपाल" },

            { name: "कार्यालय/शाखा", link: "/hi/प्रशासन/कार्यालय-अनुभाग" },
            { name: "विशेष प्रकोष्ठ एवं समितियां", link: "/hi/प्रशासन/विशेष-सेल-एवं-समितियां" },


        ]
    },


    {
        name: "शैक्षणिक",
        "dropdown": [
            {
                "name": "संकाय एवं विभाग",
                "dropdown": [
                    {
                        "name": "वेद-वेदांग संकाय",
                        "dropdown": [
                            {
                                name: "वेद विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/वेद-विभाग"

                            },

                            {
                                name: "व्याकरण विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/व्याकरण-विभाग"


                            },

                            {
                                name: "ज्योतिष विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/ज्योतिष-विभाग"

                            },

                            {
                                "name": "धर्मशास्त्र विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/धर्मशास्त्र-विभाग"

                            },


                        ]
                    },



                    {
                        "name": "साहित्य एवं संस्कृति संकाय",
                        "dropdown": [
                            {
                                "name": "साहित्य विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/साहित्य-एवं-संस्कृति-संकाय/साहित्य-विभाग"

                            },
                            {
                                "name": "हिंदू अध्ययन विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/साहित्य-एवं-संस्कृति-संकाय/हिंदू-अध्ययन-विभाग"

                            }
                        ]
                    },
                    {
                        "name": "दर्शन संकाय",
                        "dropdown": [
                            {
                                "name": "दर्शन विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/दर्शन-संकाय/दर्शन-विभाग"

                            },
                            {
                                "name": "योग विभाग", link: "/hi/शैक्षणिक/संकाय-एवं-विभाग/दर्शन-संकाय/योग-विभाग"

                            }
                        ]
                    }


                ]
            },



            {
                "name": "शोध एवं प्रकाशन", link: "/hi/शैक्षणिक/शोध-एवं-प्रकाशन"

            },
            {
                "name": "शोध केंद्र/पीठ",
                "dropdown": [
                    {
                        "name": "सरस्वती सभ्यता शोध केंद्र", link: "/hi/शैक्षणिक/शोध-केंद्र-पीठ/सरस्वती-सभ्यता-शोध-केंद्र"


                    },
                    {
                        "name": "कठ-कपिष्ठल शोध केंद्र", link: "/hi/शैक्षणिक/शोध-केंद्र-पीठ/कठ-कपिष्ठल-शोध-केंद्र"

                    },
                    {
                        "name": "महर्षि वाल्मीकि शोध केंद्र", link: "/hi/शैक्षणिक/शोध-केंद्र-पीठ/महर्षि-वाल्मीकि-शोध-केंद्र"

                    },
                    {
                        "name": "भारतीय ज्ञानपरम्परा शोध एवं प्रशिक्षण केंद्र", link: "/hi/शैक्षणिक/शोध-केंद्र-पीठ/भारतीय-ज्ञानपरम्परा-शोध-एवं-प्रशिक्षण-केंद्र"

                    },
                    {
                        "name": "48 कोस कुरुक्षेत्र तीर्थ शोध एवं प्रशिक्षण केन्द्र", link: "/hi/शैक्षणिक/शोध-केंद्र-पीठ/48-कोस-कुरुक्षेत्र-तीर्थ-शोध-एवं-प्रशिक्षण-केन्द्र"

                    }
                ]
            },
            {
                "name": "डिप्लोमा एवं अन्य प्रशिक्षण केंद्र",
                "dropdown": [
                    {
                        "name": "वेद डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/वेद-डिप्लोमा"

                    },
                    {
                        "name": "वास्तुशास्त्र डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/वास्तुशास्त्र-डिप्लोमा"

                    },
                    {
                        "name": "कर्मकांड/पौरोहित्य डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/कर्मकांड-पौरोहित्य-डिप्लोमा"

                    },
                    {
                        "name": "ज्योतिष डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/ज्योतिष-डिप्लोमा"

                    },
                    {
                        "name": "योग डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/योग-डिप्लोमा"

                    },
                    {
                        "name": "संस्कृत भाषा दक्षता डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/संस्कृत-भाषा-दक्षता-डिप्लोमा"

                    },
                    {
                        "name": "गीता में जीवन प्रबंधन डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/गीता-में-जीवन-प्रबंधन-डिप्लोमा"

                    },
                    {
                        "name": "अंग्रेजी-हिंदी-अंग्रेजी अनुवाद डिप्लोमा", link: "/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/अंग्रेजी-हिंदी-अंग्रेजी-अनुवाद-डिप्लोमा"

                    }
                ]
            },

            {
                "name": "गतिविधियां",
                "dropdown": [
                    { "name": "एन.सी.सी. (NCC)", "link": "/hi/शैक्षणिक/गतिविधियां/एन-सी-सी" },
                    { "name": "एन.एस.एस. (NSS)", "link": "/hi/शैक्षणिक/गतिविधियां/एन-एस-एस" },
                    { "name": "क्रीड़ा एवं खेल", "link": "/hi/शैक्षणिक/गतिविधियां/क्रीड़ा-एवं-खेल" },
                    { "name": "सांस्कृतिक गतिविधियां", "link": "/hi/शैक्षणिक/गतिविधियां/सांस्कृतिक-गतिविधियां" }
                ]
            },
            {
                "name": "शैक्षणिक दिनदर्शिका",
                "link": "/hi/शैक्षणिक/शैक्षणिक-दिनदर्शिका"
            },
            {
                "name": "समय सारिणी",
                "link": "/hi/शैक्षणिक/समय-सारिणी"
            },
            {
                "name": "पाठ्यक्रम ", link: "/hi/शैक्षणिक/पाठ्यक्रम"

            },




            {
                "name": "पंजीकृत शोध-छात्र",
                "link": "/hi/शैक्षणिक/पंजीकृत-शोध-छात्र"
            },
            {
                "name": "दीक्षांत समारोह",
                "link": "/hi/शैक्षणिक/दीक्षांत-समारोह"
            },

        ]
    },



    {
        "name": "प्रवेश", link: "/hi/प्रवेश"

    },
    {
        "name": "पुस्तकालय", link: "/hi/पुस्तकालय"

    },
    {
        "name": "परीक्षा", link: "/hi/परीक्षा"

    },
    {
        "name": "सुविधाएं",
        "dropdown": [
            {
                "name": "छात्रावास", link: "/hi/सुविधाएं/छात्रावास"

            },
            { "name": "अतिथिगृह ", "link": "/hi/सुविधाएं/अतिथिगृह" },
            { "name": "स्वास्थ्य केंद्र", "link": "/hi/सुविधाएं/स्वास्थ्य-केंद्र" },
            { "name": "यज्ञशाला", "link": "/hi/सुविधाएं/यज्ञशाला" },
            { "name": "कम्प्यूटर लैब", "link": "/hi/सुविधाएं/कम्प्यूटर-लैब" },
            { "name": "पुस्तकालय", "link": "/hi/पुस्तकालय" },
            { "name": "योगशाला", "link": "/hi/सुविधाएं/योगशाला" },
            { "name": "क्रीडास्थल", "link": "/hi/सुविधाएं/क्रीडास्थल" },
            { "name": "जलपानगृह / कैण्टीन", "link": "/hi/सुविधाएं/कैण्टीन" }
        ]
    },

    {
        "name": "विज्ञप्ति एवं निविदा", link: "/hi/विज्ञप्ति-एवं-निविदा"
    },
    {
        "name": "सूचना का अधिकार", link: "/hi/सूचना-का-अधिकार"
    },

    {
        "name": "संपर्क",
        "dropdown": [
            { "name": "कुलपति कार्यालय", "link": "/hi/संपर्क/कुलपति-कार्यालय" },
            { "name": "कुलसचिव कार्यालय", "link": "/hi/संपर्क/कुलसचिव-कार्यालय" },
            { "name": "विश्वविद्यालय के अधिकारी", "link": "/hi/संपर्क/विश्वविद्यालय-के-अधिकारी" },
            { "name": "जनसंपर्क अधिकारी कार्यालय (PRO)", "link": "/hi/संपर्क/जनसंपर्क-अधिकारी-कार्यालय" },
            {
                "name": "स्टाफ डायरेक्ट्री", link: "/hi/संपर्क/स्टाफ-डायरेक्ट्री"

            }
        ]
    },


    {
        "name": "सहायता", link: "/hi/सहायता"

    },





    {
        "name": "विविध ", link: "/hi/विविध"

    },








];


const NavbarMenu = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openSubDropdown, setOpenSubDropdown] = useState(null);
    const [openThirdDropdown, setOpenThirdDropdown] = useState(null);
    const [openFourthDropdown, setOpenFourthDropdown] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleToggleMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleDropdownClick = (index) => {
        if (openDropdown === index) {
            setOpenDropdown(null);
        } else {
            setOpenDropdown(index);
        }
    };

    const handleSubDropdownClick = (index, subIndex) => {
        const key = `${index}-${subIndex}`;
        if (openSubDropdown === key) {
            setOpenSubDropdown(null);
        } else {
            setOpenSubDropdown(key);
        }
    };

    const handleThirdDropdownClick = (index, subIndex, nestedIndex) => {
        const key = `${index}-${subIndex}-${nestedIndex}`;
        if (openThirdDropdown === key) {
            setOpenThirdDropdown(null);
        } else {
            setOpenThirdDropdown(key);
        }
    };

    const handleFourthDropdownClick = (index, subIndex, nestedIndex, thirdIndex) => {
        const key = `${index}-${subIndex}-${nestedIndex}-${thirdIndex}`;
        if (openFourthDropdown === key) {
            setOpenFourthDropdown(null);
        } else {
            setOpenFourthDropdown(key);
        }
    };

    return (
        <div className={`navbar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <div className="mobile-menu-toggle" onClick={handleToggleMenu}>
                <i className="fas fa-bars"></i>
            </div>


            <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                {menuItems.map((item, index) => (
                    <li key={index} className="nav-item">
                        <a href={item.link} onClick={() => item.dropdown && handleDropdownClick(index)}>
                            {item.name}
                            {item.dropdown && <i className="fas fa-caret-down ps-1"></i>}
                        </a>
                        {item.dropdown && (
                            <ul className={`dropdown ${openDropdown === index ? 'active' : ''}`}>
                                {item.dropdown.map((subItem, subIndex) => (
                                    <li key={subIndex} className="dropdown-item">
                                        <a href={subItem.link} onClick={() => subItem.dropdown && handleSubDropdownClick(index, subIndex)}>
                                            {subItem.name}
                                            {subItem.dropdown && <i className="fas fa-caret-right" style={{ float: "right" }}></i>}
                                        </a>
                                        {
                                            subItem.dropdown && (
                                                <ul className={`sub-dropdown ${openSubDropdown === `${index}-${subIndex}` ? 'active' : ''}`}>
                                                    {subItem.dropdown.map((nestedItem, nestedIndex) => (
                                                        <li key={nestedIndex} className="nested-dropdown-item">
                                                            <a href={nestedItem.link} onClick={() => nestedItem.dropdown && handleThirdDropdownClick(index, subIndex, nestedIndex)}>
                                                                {nestedItem.name}
                                                                {nestedItem.dropdown && <i className="fas fa-caret-right " style={{ float: "right" }}></i>}
                                                            </a>
                                                            {nestedItem.dropdown && (
                                                                <ul className={`third-dropdown ${openThirdDropdown === `${index}-${subIndex}-${nestedIndex}` ? 'active' : ''}`}>
                                                                    {nestedItem.dropdown.map((thirdItem, thirdIndex) => (
                                                                        <li key={thirdIndex}>
                                                                            <a href={thirdItem.link} onClick={() => thirdItem.dropdown && handleFourthDropdownClick(index, subIndex, nestedIndex, thirdIndex)}>
                                                                                {thirdItem.name}
                                                                                {thirdItem.dropdown && <i className="fas fa-caret-right" style={{ float: "right" }}></i>}
                                                                            </a>
                                                                            {thirdItem.dropdown && (
                                                                                <ul className={`fourth-dropdown ${openFourthDropdown === `${index}-${subIndex}-${nestedIndex}-${thirdIndex}` ? 'active' : ''}`}>
                                                                                    {/* Fourth-level dropdown items */}
                                                                                </ul>
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )
                                        }
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div >
    );
};

export default NavbarMenu;